var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.45068,
    width: 2,
    height: 1,
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.45068,
    y: 1,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.45068,
    y: 2,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.45117,
    y: 3,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.45068,
    y: 4,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.45068,
    y: 5,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.45068,
    y: 6,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.45068,
    y: 4,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.45068,
    y: 5,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4.45117,
    y: 6,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.45068,
    y: 7,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 2.45068,
    y: 8,
    width: 1,
    height: 7,
    fill: "#232323"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    transform: "matrix(-1 0 0 1 9.45068 3)",
    fill: "#232323"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 1,
    transform: "matrix(-1 0 0 1 13.4507 15)",
    fill: "#232323"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 10.4507 4)",
    fill: "#232323"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 11.4507 5)",
    fill: "#232323"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 12.4507 6)",
    fill: "#232323"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 13.4507 7)",
    fill: "#232323"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 7,
    transform: "matrix(-1 0 0 1 14.4507 8)",
    fill: "#232323"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.450684,
    y: 7,
    width: 1,
    height: 1,
    fill: "#232323"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 10.4507 1)",
    fill: "#232323"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 11.4507 2)",
    fill: "#232323"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 12.4507 3)",
    fill: "#232323"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 4,
    transform: "matrix(-1 0 0 1 13.4507 1)",
    fill: "#232323"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 14.4507 5)",
    fill: "#232323"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 15.4507 6)",
    fill: "#232323"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 16.4507 7)",
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.0cbe2b5e86699cc38bc6dc6e5c8de84c.svg";
export { ForwardRef as ReactComponent };